import { makeStyles } from "@material-ui/core/styles";
import { blue900 } from "../../../../components/common/PL/constants";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    borderRadius: 16,
    overflow: "hidden",
    border: "1px solid #D9DDE2",
    boxShadow: "0 1px 3px rgba(0, 51, 80, 0.08)",
    boxSizing: "border-box",
  },
  rootSimple: {
    backgroundColor: "#F4F6F8",
  },
  rootDetailed: {
    backgroundColor: "#FFFFFF",
  },
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(2),
  },
  headerDetailed: {
    backgroundColor: "#F4F6F8",
  },
  avatar: {
    width: 44,
    height: 44,
    background: "linear-gradient(135deg, #0ADBDB 0%, #2BE65E 100%)",
    color: "#FFFFFF",
    fontSize: "0.95rem",
    fontWeight: 700,
  },
  info: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    minWidth: 0,
  },
  name: {
    color: blue900,
    fontWeight: 700,
    fontSize: "1rem",
    lineHeight: 1.2,
    margin: 0,
    "&.MuiTypography-root": {
      fontWeight: 700,
    },
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    padding: theme.spacing(1.75, 2),
    borderTop: "1px solid #E5E7EB",
  },
  label: {
    color: "#8A8D96",
    fontSize: "0.8rem",
    fontWeight: 600,
    letterSpacing: "0.04em",
    margin: 0,
  },
  value: {
    color: blue900,
    fontWeight: 700,
    fontSize: "0.95rem",
    textAlign: "right",
    margin: 0,
    "&.MuiTypography-root": {
      fontWeight: 700,
    },
  },
}));

export default useStyles;
